import React, { useEffect, useState } from "react";
import { useAxiosContext } from "../../../context/AxiosContext";
import MultiSelectBox from "../../../components/FormComponents/MultiSelectBox";

const FieldVisibility = ({ editFieldData, setEditFieldData, tableID }) => {
  const { handleError, axiosInstance } = useAxiosContext();
  const [options, setOptions] = useState([]);
  const fetchStateMachine = async () => {
    try {
      let { data } = await axiosInstance.get(`/state-machine/${tableID}`);
      data = data.config;
      const allActivities = data.activities.map((act) => ({ id: act.id, name: act.name }));
      setOptions(allActivities);
    } catch (error) {
      handleError(error);
    }
  };
  const handleVisibility = (key, data) => {
    const idOnlyData = data.map((item) => item.id);

    setEditFieldData((prevState) => ({
      ...prevState,
      visibility_settings: {
        ...prevState.visibility_settings,
        [key]: idOnlyData
      }
    }));
  };

  //get object from ids
  // const getValueData = (key) => {
  //   return options.filter((option) => editFieldData.visibility_settings[key].includes(option.id));
  // };
  useEffect(() => {
    fetchStateMachine();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <MultiSelectBox
        options={options || []}
        selectedData={editFieldData.visibility_settings.hide}
        onChange={(data) => handleVisibility("hide", data)}
        label="Hide field for activities "
      />

      <MultiSelectBox
        options={options || []}
        selectedData={editFieldData.visibility_settings.disable}
        onChange={(data) => handleVisibility("disable", data)}
        label="Disable field for activities "
      />
    </>
  );
};

export default FieldVisibility;
